// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"2d064b83","444":"3ef75811"}[chunkId] + ".chunk.js";
};